import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Filter from 'ui/filter/Filter'
import NoData from 'ui/no-data/NoData'
import SearchField from 'ui/search-field/SearchField'
import Pagination from 'ui/pagination/Pagination'
import TimeFilter from 'ui/TimeFilter'

import './community-table.scss'
import './community-table-navigation.scss'

const propTypes = {
  initStore: PropTypes.shape({}),
  children: PropTypes.node,
  filtersList: PropTypes.shape([]),
  noDataText: PropTypes.node,
  search: PropTypes.bool,
  pagination: PropTypes.bool,
  tableWithoutMargin: PropTypes.bool,
  noDataIcon: PropTypes.bool,
  forceNoData: PropTypes.bool,
}

const defaultProps = {
  pagination: true,
  search: true,
  noDataText: I18n.t('react.cabinet.common.no_data'),
  tableWithoutMargin: false,
  noDataIcon: true,
  forceNoData: false,
  initStore: {},
}

@observer
class CommunityTable extends Component {
  static Head = ({ children }) => (
    <thead>
      <tr>{children}</tr>
    </thead>
  )
  static Body = ({ children, embedBody }) => (embedBody ? children : <tbody>{children}</tbody>)

  constructor(props) {
    super(props)

    this.table = React.createRef()
    this.tableContainer = React.createRef()
  }

  render() {
    const {
      children,
      filtersList,
      filterStores,
      initStore,
      pagination,
      search,
      timeFilter,
      timeFilterDefaultValue,
      itemsPerPageOptions,
      tableWithoutMargin,
      tableModalScroll,
      refer = this.tableContainer,
      timezone,
      tableWithRadios,
      noDataIcon,
      forceNoData,
      applyFilters,
      pageToGoField = true,
      scrollIntoView = false,
    } = this.props

    const { list, loading: isLoading } = initStore

    const tableChildren = React.Children.map(children, (child) => React.cloneElement(child))
    const scrollCurrent = scrollIntoView ? this.table : refer

    const tableContainer = classNames('community-table-container', {
      'community-table-container--one-screen-modal': tableModalScroll,
      'community-table-container--table-with-radios': tableWithRadios,
      'community-table-container--with-x-axis-scrollbar':
        this.table?.current?.clientWidth > refer?.current?.clientWidth,
    })

    const tableClasses = classNames('community-table', {
      'community-table--no-margin': tableWithoutMargin,
    })

    return (
      <Fragment>
        <div className='community-table-navigation'>
          <div className='community-table-navigation__left-block'>
            {filtersList && (
              <Fragment>
                <Filter
                  fetchOptionsStores={filterStores}
                  {...{
                    filtersList,
                    initStore,
                    timezone,
                    applyFilters,
                  }}
                />
              </Fragment>
            )}
            {timeFilter && <TimeFilter initStore={initStore} defaultValue={timeFilterDefaultValue} />}
          </div>
          <div className='community-table-navigation__right-block'>
            {search && <SearchField initStore={initStore} />}
          </div>
        </div>
        <div className={tableContainer} ref={refer}>
          <table className={tableClasses} ref={this.table}>
            {tableChildren}
          </table>
        </div>
        {((!isLoading && !list?.length && noDataIcon) || forceNoData) && <NoData />}
        {pagination && (
          <Pagination
            pageToGoField={pageToGoField}
            itemsNumberField
            showItemsPerPageField
            showItemsPerPageOptions={itemsPerPageOptions}
            initStore={initStore}
            refToScroll={scrollCurrent}
            scrollToCurrent={scrollIntoView}
          />
        )}
      </Fragment>
    )
  }
}

CommunityTable.displayName = 'CommunityTable'
CommunityTable.propTypes = propTypes
CommunityTable.defaultProps = defaultProps

export default CommunityTable
